export const foundingTraderCampaignCopy = {
  heading: "You are one of the ten.",
  primaryCta: "Get Started",
  telegramHandle: "charliebus",
  telegramPrefill:
    "I would like to be onboarded as a near.com Founding Trader.",
} as const
